import React, { FC, memo } from 'react'
import { useIntl } from 'react-intl'

import '@culturehq/add-to-calendar/dist/styles.css'
import { Input } from 'antd'

import { LoginFormProps } from './Home'

const LoginForm: FC<LoginFormProps> = ({
    eventId,
    googler,
    channelId,
    handleSubmit,
    eventOpen,
    code,
    HandleInputChange,
    data
    // style,
}) => {
    const intl = useIntl()

    return (
        <div className="landing-page-login-content">
            <div className="landing-page-login-content-box">
                <form onSubmit={(e) => handleSubmit(e, eventId, channelId)} className="login-form">
                    {googler ? (
                        <div className="login-input-gp">
                            <Input
                                disabled={false}
                                type="text"
                                value={code}
                                className={`googler`}
                                onChange={HandleInputChange}
                                placeholder="Your LDAP"
                            />
                            <div className="googleAppend">@google.com</div>
                        </div>
                    ) : (
                        <Input
                            disabled={!eventOpen}
                            type="text"
                            value={code}
                            className={`login-input`}
                            onChange={HandleInputChange}
                            placeholder={
                                eventOpen
                                    ? intl.formatMessage({ id: 'landingPage.input_placeholder_open' })
                                    : intl.formatMessage({ id: 'landingPage.input_placeholder_notOpen' })
                            }

                            style = { {
                                borderColor: data && data[0]?.attributes?.landing_config?.sub_color || '',
                                ...(eventOpen && {
                                    border: `1px solid ${data && data[0]?.attributes?.landing_config?.priminary_color || ''}`,  
                                    boxShadow: `0px 0px 10px ${data && data[0]?.attributes?.landing_config?.priminary_color_100 || ''}`,  
                                }),
                            }}
                        />
                    )}

                    <button className={`login-btn`} disabled={!eventOpen} style={{
                        
                        backgroundColor:`${data && data[0]?.attributes?.landing_config?.priminary_color || ''}`,
                        ...(eventOpen
                                ? {
                                      '&:hover': {
                                          backgroundColor: `${data && data[0]?.attributes?.landing_config?.priminary_color_600 || ''}`, // 只有在 eventOpen 為 true 時才應用 hover 樣式
                                      },
                                  }
                                : {
                                      backgroundColor: `${data && data[0]?.attributes?.landing_config?.sub_color || ''}`, // 當按鈕被禁用時的背景色
                                  }),
                        
                    }} >
                        {eventOpen
                            ? intl.formatMessage({ id: 'landingPage.button_text_open' })
                            : intl.formatMessage({ id: 'landingPage.button_text_not_open' })}
                    </button>
                </form>
            </div>
        </div>
    )
}

export default memo(LoginForm)
